import React from "react";
import utils from '../../../common/utils'
import useBookStatisticsSummary from './hooks/useBookStatisticsSummary'
import StatisticsTable from "../../../common/StatisticsTable";
import BooksitoutImages from "../../../images/BooksitoutImages";

const BookStatisticsTable: React.FC<{
    year: number
    backgroundColorType?: 'card-card' | 'card'
}> = ({year, backgroundColorType}) => {
    const [statistics, isLoading] = useBookStatisticsSummary(year)

    const statisticsData = (statistics) => [
        {
            id: 1,
            icon: BooksitoutImages.Statistics.time,
            name: '총 독서시간',
            value: statistics.yearStatistics.totalReadTime != null ? utils.formatMinutesCompact(statistics.yearStatistics.totalReadTime) : '-',
        },
        {
            id: 2,
            icon: BooksitoutImages.Statistics.average,
            name: '하루 평균',
            value: statistics.dayStatistics.averageReadTime != null ? utils.formatMinutesCompact(statistics.dayStatistics.averageReadTime) : '-',
        },
        {
            id: 3,
            icon: BooksitoutImages.Statistics.book,
            name: '읽은 책',
            value: `${statistics.yearStatistics.totalReadBookCount != null && statistics.yearStatistics.totalReadBookCount}권`,
        },
        {
            id: 4,
            icon: BooksitoutImages.Statistics.star,
            name: '평균별점',
            value: `${statistics.yearStatistics.averageStar != null && statistics.yearStatistics.averageStar.toFixed(1)}점`,
        },
        {
            id: 5,
            icon: BooksitoutImages.Statistics.longestDay,
            name: '최대 독서 시간',
            value: statistics.dayStatistics.mostReadTime != null ? utils.formatMinutesCompact(statistics.dayStatistics.mostReadTime) : '-',
        },
        {
            id: 6,
            icon: BooksitoutImages.Statistics.page,
            name: '총 읽은 페이지',
            value: `${statistics.yearStatistics.totalReadPage != null && utils.insertCommas(statistics.yearStatistics.totalReadPage)}`,
        },
        {
            id: 7,
            icon: BooksitoutImages.Statistics.averageReadingDays,
            name: '평균 완독 소요일',
            value: statistics.yearStatistics.averageReadingDays != null ? `${utils.insertCommas(Math.round(statistics.yearStatistics.averageReadingDays))}일` : '-',
        },
    ]

    return (
        // @ts-ignore
        <StatisticsTable isLoading={isLoading} rows={statisticsData(statistics)} backgroundColorType={backgroundColorType}/>
    )
}

export default BookStatisticsTable
